export default function Odo({reference}) {

    return <audio loop={true} ref={reference} autoPlay controls className={'hidden'}>
        <source src="horse.ogg" type="audio/ogg"/>
        <source src="/welcome.mp3" type="audio/mpeg"/>
    </audio>
}